module.exports = __webpack_public_path__ + "img/faaccf7fffffda4c5772837d381b8048.svg";